export class Theme {

  public id: string;
  public title: string;
  public description: string;
  public fontFamily: string;
  public bgColor: string;
  public btnColor: string;
  public iconColor: string;

}
